import { useEffect, useState } from "react";
import { mediaUrl } from "@/lib/api";

const initialsOf = (name = "", email = "") => {
  const src = (name || email || "").trim();
  if (!src) return "?";
  const parts = src.split(/[\s@._-]+/).filter(Boolean);
  const first = parts[0]?.[0] || "";
  const second = parts[1]?.[0] || "";
  return (first + second).toUpperCase().slice(0, 2) || "?";
};

const Avatar = ({ name, email, picture, size = 44, className = "", testId }) => {
  // A fresh picture (a new upload, or a different guest) deserves a fresh
  // chance to load — a 404 on the last one is not this one's fault.
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [picture]);

  const dim = { width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.36)) };
  if (picture && !broken) {
    return (
      <img
        data-testid={testId}
        src={mediaUrl(picture)}
        alt={name || email || "avatar"}
        style={dim}
        className={`rounded-full object-cover ${className}`}
        onError={() => setBroken(true)}
      />
    );
  }
  // The letter tile is the same dark neutral as the tenant's — one design
  // language, not a per-person color lottery.
  return (
    <div
      data-testid={testId}
      style={dim}
      className={`rounded-full bg-neutral-900 text-white flex items-center justify-center font-black tracking-tight ${className}`}
      aria-label={name || email || "avatar"}
    >
      {initialsOf(name, email)}
    </div>
  );
};

export default Avatar;
